export default function compareArrays(array1, array2) {
  array1.sort();
  array2.sort();
  if (array1.length !== array2.length) { return false }

  for (var i = 0; i < array1.length; i++) {
    if (array1[i] !== array2[i]) return false;
  }
  return true;
}